<template>
  <section v-if="lang[4]">
    <Title
      v-if="title && title.UpdatePhoneNumber"
      :title-name="title.UpdatePhoneNumber.titleName"
      :title-link="title.UpdatePhoneNumber.titleLink"
    />
    <div v-if="groupTaxi" class="container pt-3">
      <span
        class="mt-2 mb-2"
        v-html="replaceStr(lang['phone_matrix_taxi'].SFS_LANG_ROW_1, ['<num_taxi>'], [groupTaxi.length])"
      ></span>
      <form id="groupPax" @submit.prevent="">
        <div class="list-passenger-share-room popupoverflow">
          <div v-for="(group, groupKey) in groupTaxi" :key="groupKey">
            <span style="color: #71aedc">Taxi {{ group[0].taxi }}</span>
            <div v-for="(pax, paxKey) in group" :key="paxKey" class="mt-1 mb-2">
              {{ pax.last_name }}/ {{ pax.first_name }} {{ pax.title }}
              <VueTelInput
                v-model="pax.phone_number"
                v-bind="{ validCharactersOnly: true, inputId: group_key + '-' + paxKey }"
                :class="{ 'validation-failed': !pax.isValidPhone }"
                @input="onInput"
              />
            </div>
          </div>
        </div>
        <div class="save-button pt-2">
          <button type="submit" class="btnDefault" @click="SaveUpdatePhoneNumber()">Save</button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueTelInput from 'vue-tel-input'
import Title from '@/components/Title/index'
import '@/assets/scss/modules/UpdatePhoneNumber.scss'
export default {
  name: 'UpdatePhoneNumber',
  components: { Title, VueTelInput },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      curPaxInfo: null,
      taxiService: {},
      listPax: [],
      groupTaxi: [],
      group_key: 0,
      pax_key: 0
    }
  },
  computed: {
    ...mapGetters({
      Voucher: 'Taxi/Voucher',
      Services: 'Home/Services',
      PaxsGroup: 'Home/PaxsGroup'
    })
  },
  watch: {
    PaxsGroup: function () {
      this.initData()
    },
    Voucher: function () {
      this.initData()
    },
    Services: function () {
      this.initData()
    }
  },
  created() {
    this.$store.dispatch('Home/getServices')
    this.$store.dispatch('Home/getPaxsGroup'), this.$store.dispatch('Taxi/getTaxiVoucher')
    this.initData()
    document.addEventListener('focusin', this.focusChanged)
  },
  beforeUnmount() {
    document.removeEventListener('focusin', this.focusChanged)
  },
  methods: {
    replaceStr,
    focusChanged(event) {
      if (!_.isEmpty(event.target.id)) {
        let aKey = event.target.id.split('-')
        this.group_key = parseInt(aKey[0])
        this.pax_key = parseInt(aKey[1])
      }
    },
    initData() {
      let self = this
      if (!_.isEmpty(this.PaxsGroup) && !_.isNull(this.Voucher) && !_.isEmpty(this.Services)) {
        this.listPax = _.cloneDeep(this.PaxsGroup)
        this.taxiService = _.find(this.Services, function (service) {
          return service.service_id == 4
        })
        if (
          !_.isEmpty(this.taxiService) &&
          !_.isEmpty(this.taxiService.params) &&
          !_.isEmpty(this.taxiService.params.matrix_share_taxi)
        ) {
          let matrix = this.taxiService.params.matrix_share_taxi
          if (!_.isEmpty(matrix)) {
            _.forEach(matrix, function (line, key) {
              _.forEach(self.listPax, function (pax) {
                if (line.includes(pax.passenger_id.toString())) {
                  pax.taxi = key + 1
                }
              })
            })
          }
        } else {
          _.forEach(this.listPax, function (pax, key) {
            pax.taxi = key + 1
          })
        }
        let paxByGroup = _.groupBy(self.listPax, 'taxi')
        self.groupTaxi = []
        _.forEach(paxByGroup, function (paxs) {
          let issetPhoneNumber = _.filter(paxs, 'phone_number')
          if (_.isEmpty(issetPhoneNumber)) {
            _.forEach(paxs, function (paxs) {
              paxs.isValidPhone = true
            })
            self.groupTaxi.push(paxs)
          }
        })
      }
    },
    SaveUpdatePhoneNumber() {
      let self = this
      let isSubmit = true
      let listPax = []
      _.forEach(self.groupTaxi, function (group) {
        let paxs = _.filter(group, 'phone_number')
        if (_.isEmpty(paxs)) {
          isSubmit = false
        } else {
          _.forEach(paxs, function (pax) {
            if (!pax.isValidPhone && !_.isEmpty(pax.phone_number)) {
              isSubmit = false
              return
            }
            listPax.push({ id: pax.passenger_id, phone_number: pax.phone_number.replace(/ /g, '') })
          })
        }
      })
      if (isSubmit) {
        self.$store.dispatch('UpdatePhoneNumber/updatePhoneNumber', { data: listPax, secret: self.secret }).then((response) => {
          if (response) {
            _.forEach(listPax, (pax) => {
              let passenger = _.find(self.PaxsGroup, { passenger_id: pax.id })
              if (passenger) {
                passenger.phone_number = pax.phone_number
              }
            })
            self.$router.push({ path: '/taxi-service', query: { secret: self.secret } }).catch(() => {})
          }
        })
      } else {
        this.$swal(this.lang['phone_matrix_taxi'].SFS_LANG_ROW_2)
      }
    },
    onInput(formattedNumber, { number, isValid, country }) {
      let self = this
      if (number.input == '00' || number.input == '+00') {
        self.groupTaxi[self.group_key][self.pax_key].phone_number = '+'
      } else if (number.international) {
        self.groupTaxi[self.group_key][self.pax_key].phone_number = number.international
      }
      self.groupTaxi[self.group_key][self.pax_key].isValidPhone = isValid
      if (!formattedNumber) {
        self.groupTaxi[self.group_key][self.pax_key].isValidPhone = true
      }
    }
  }
}
</script>
